export const GTM_IDS = {
  DEFAULT: "GTM-K56899"
};
